const legacySectionRedirects = {
  "/code": "/blog?theme=engineering",
  "/computing": "/blog?theme=engineering",
  "/ai": "/blog?theme=engineering",
  "/work": "/blog?theme=startups",
  "/business": "/blog?theme=investing",
  "/food": "/blog?theme=food",
  "/life": "/blog?theme=life",
  "/about": "/about",
}

const normalizePathname = pathname => {
  const trimmed = pathname.replace(/\/+$/, "")
  return trimmed || "/"
}

exports.onClientEntry = () => {
  if (typeof window === "undefined") {
    return
  }

  const rawPath = normalizePathname(window.location.pathname)
  const redirectTarget = legacySectionRedirects[rawPath.toLowerCase()]

  if (!redirectTarget) {
    return
  }

  const targetUrl = new URL(redirectTarget, window.location.origin)
  const currentPathWithSearch = `${rawPath}${window.location.search}`
  const targetPathWithSearch = `${normalizePathname(targetUrl.pathname)}${targetUrl.search}`

  if (currentPathWithSearch === targetPathWithSearch) {
    return
  }

  window.location.replace(redirectTarget)
}
